import React from 'react';
import { clsx } from 'clsx';

/**
 * Trade-detail data card (prototype `.card` / `.card-h` / `.card-b`). The
 * existing `Card` uses a vertical `p-6` header; this panel has the horizontal
 * header with a leading icon + right-aligned meta the redesign's Economics /
 * Trade Terms cards use. Surface + hairline border on the canvas.
 */
export function Panel({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div className={clsx('overflow-hidden rounded-[10px] border border-lr-border bg-lr-surface', className)}>
      {children}
    </div>
  );
}

interface PanelHeaderProps {
  /** Leading icon node (size it on the caller, e.g. h-[15px] w-[15px] text-lr-muted). */
  icon?: React.ReactNode;
  title: React.ReactNode;
  /** Right-aligned faint meta (e.g. "as of last mark · May 26"). */
  meta?: React.ReactNode;
  className?: string;
}

export function PanelHeader({ icon, title, meta, className }: PanelHeaderProps) {
  return (
    <div
      className={clsx(
        'flex items-center gap-2 border-b border-lr-border px-[18px] py-[13px] text-[13.5px] font-semibold text-lr-fg',
        className,
      )}
    >
      {icon}
      <span>{title}</span>
      {meta != null && meta !== '' && (
        <span className="ml-auto text-xs font-medium text-lr-faint">{meta}</span>
      )}
    </div>
  );
}

export function PanelBody({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <div className={clsx('p-[18px]', className)}>{children}</div>;
}
